import React, { useContext, useEffect } from "react";
import JobCard from "./JobCard";
import { Box, Grid } from '@mui/material'
import { styled } from '@mui/material/styles';
import { DataContext } from "../context/DataContext";


const JobBoxList = styled(Box)`
    padding: 0 15px 15px 15px;
`;

const JobListing = () => {
    const { originalJobData, jobData, setJobData, locationFilter } = useContext(DataContext);

    useEffect(() => {
        if (locationFilter.length === 0) {
            setJobData(originalJobData)
        } else {
            let filterJobs = originalJobData;

            const countrySelections = locationFilter.filter(x => x.label === "Country").map(x => x.value);
            const stateSelections = locationFilter.filter(x => x.label === "State").map(x => x.value);
            const citySelections = locationFilter.filter(x => x.label === "City").map(x => x.value);
            const categorySelections = locationFilter.filter(x => x.label === "Category").map(x => x.value);
            const divisionSelections = locationFilter.filter(x => x.label === "Division").map(x => x.value);
            const statusSelections = locationFilter.filter(x => x.label === "Status").map(x => x.value);

            if (countrySelections.length > 0) {
                filterJobs = filterJobs.filter(x => countrySelections.includes(x.countryname))
            }
            
            if (stateSelections.length > 0) {
                filterJobs = filterJobs.filter(x => stateSelections.includes(x.statename))
            }
            
            if (citySelections.length > 0) {
                filterJobs = filterJobs.filter(x => citySelections.includes(x.city))
            }

            if (categorySelections.length > 0) {
                filterJobs = filterJobs.filter(x => categorySelections.includes(x.category))
            }

            if (divisionSelections.length > 0) {
                filterJobs = filterJobs.filter(x => divisionSelections.includes(x.division))
            }

            if (statusSelections.length > 0) {
                filterJobs = filterJobs.filter(x => statusSelections.includes(x.fulltime))
            }
            
            setJobData(filterJobs);
        }

    }, [locationFilter]);


    return (
        <JobBoxList>
            <Grid container spacing={2}>
                {jobData.map((job) => {
                    return (
                        <Grid key={job.uniqueid} item sm={4} xs={12}>
                            <JobCard job={job} />
                        </Grid>
                    )
                })}
            </Grid>
        </JobBoxList>
    )
};

export default JobListing;